// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2Iw6I","obliqueLineWrap":"membershipbadge_obliqueLineWrap__18kSy","obliqueLine":"membershipbadge_obliqueLine__1Pf8j"};